{
    "component-card-search-list.empty-state.title.non-final": "<strong>このリポジトリをソフトウェア コンポーネントにリンクする</strong>",
    "component-card.add-chat-channel": "チャット チャンネルを追加",
    "component-card.chat-channels": "チャット チャンネル",
    "component-card.expander.show-more-link": "さらに {formattedCount} 件表示"
}
